import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';
export default function HeroSection() {
  return <section className="bg-gradient-to-br from-primary via-primary-dark to-primary text-white py-20 md:py-24 lg:py-32 pt-24 md:pt-28" data-id="element-216">
      <div className="container mx-auto px-4" data-id="element-217">
        <div className="flex flex-col items-center text-center" data-id="element-218">
          <motion.div className="max-w-3xl w-full" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-219">
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-220">
              <span className="block mb-2" data-id="element-221">Medico-Legal Psychiatry</span>
              <span className="block text-2xl md:text-3xl lg:text-4xl text-secondary" data-id="element-222">
                Expert Witness Psychiatric Services UK
              </span>
            </h1>
            <p className="text-lg md:text-xl mb-8 leading-relaxed opacity-90" data-id="element-223">
              Trusted independent psychiatric assessments and expert witness
              reports for solicitors, barristers, and courts across the UK.
              Providing specialist psychiatric evaluations for legal
              proceedings.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-224">
              <Button variant="secondary" size="lg" href="/contact" pulse data-id="element-225">
                Instruct Dr. Syed
              </Button>
              <Button variant="transparent" size="lg" href="/services" data-id="element-226">
                Our Services
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}